import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { DashboardPageComponent } from './pages/dashboard/containers';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AuthGuard, CustGuard, AdminCustGuard } from './pages/auth/guards';
import { routes as routesList } from './consts/routes';
import { CustomerComponent } from './pages/customer/components/customer/customer.component';
import { AssetlinkComponent } from './pages/assetlink/components/assetlink/assetlink.component';
import { ApprovalToolComponent } from './pages/approval-tool/approval-tool.component';
import { ApprovalToolAdminComponent } from './pages/approval-tool-admin/approval-tool-admin.component';
import { JobComponent } from './pages/job/job.component';
import { JobAdminComponent } from './pages/job-admin/job-admin.component';
import { FileNotFoundComponent } from './pages/file-not-found/file-not-found.component';
import { SwitchUserComponent } from './pages/switch-user/switch-user.component';
import { DashboardResolverService } from './resolvers/dashboard-resolver.service';

const routes: Routes = [

  {
    path: '',
    pathMatch: 'full',
    resolve: { userData: DashboardResolverService },
    component: DashboardPageComponent
  },
  {
    path: 'asset',
    pathMatch: 'full',
    canActivate: [AdminCustGuard],
    component: AssetlinkComponent

  },

  {
    path: 'customer',
    pathMatch: 'full',
    canActivate: [CustGuard],
    component: CustomerComponent
  },
  {
    path: 'approval-tool',
    pathMatch: 'full',
    canActivate: [CustGuard],
    component: ApprovalToolComponent
  },
  {
    path: 'approval-tools',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: ApprovalToolAdminComponent
  },
  {
    path: 'job',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/job-section/job-section.module').then(m => m.JobSectionModule)
  },
  {
    path: 'user',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'jobe',
    pathMatch: 'full',
    canActivate: [CustGuard],
    component: JobComponent
  },
  {
    path: 'jobs',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: JobAdminComponent
  },
  {
    path: routesList.DASHBOARD,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: DashboardPageComponent
  },
  {
    path: 'file-not-found',
    pathMatch: 'full',
    component: FileNotFoundComponent
  },
  {
    path: 'tables',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/tables/tables.module').then(m => m.TablesModule)
  },
  {
    path: ' ',
    component: NotFoundComponent
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'switch',
    pathMatch: 'full',
    canActivate: [AdminCustGuard],
    component: SwitchUserComponent
  },
  {
    path: 'customer-mapping',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/customer-mapping/customer-mapping.module').then(m => m.CustomerMappingModule)
  },
  {
    path: 'vendor-mapping',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/vendor-mapping/vendor-mapping.module').then(m => m.VendorMappingModule)
  },
  {
    path: 'institution',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/institution-management/institution-management.module').then(m => m.InstitutionManagementModule)
  },

  {
    path: 'survey',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyModule)
  },


  {
    path: 'survey-group',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/survey-group/survey-group.module').then(m => m.SurveyGroupModule)
  },

  {
    path: 'dynamic-image-tag',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/dynamic-image-tag/dynamic-image-tag.module').then(m => m.DynamicImageTagModule)
  },
  {

    path: 'roles',
    canActivate: [AdminCustGuard],
    pathMatch: 'full',
    loadChildren: () => import('./pages/user-role/user-role.module').then(m => m.UserRoleModule)
  },

  {
    path: 'customer-service-assign',
    canActivate: [AdminCustGuard],
    pathMatch: 'full',
    loadChildren: () => import('./pages/customer-assign-service/customer-assign-service.module').then(m => m.CustomerAssignServiceModule)
  },

  {

    path: 'technician-survey-mapping',
    canActivate: [AdminCustGuard],
    pathMatch: 'full',
    loadChildren: () => import('./pages/technician-survey-mapping/technician-survey-mapping.module').then(m => m.TechnicianSurveyMappingModule)
  },


  {

    path: 'atm',
    canActivate: [AdminCustGuard],
    loadChildren: () => import('./pages/atm-management/atm-management.module').then(m => m.AtmManagementModule)
  },



  {
    path: '**',
    redirectTo: '404'
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //useHash: true,
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
